var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tippy",rawName:"v-tippy"}],staticClass:"clone h-8 w-8 rounded-full bg-gray-300 flex items-center justify-center cursor-pointer",attrs:{"content":_vm.$t('actions.clone')},on:{"click":function($event){return _vm.$emit('handleCloneField',_vm.row )}}},[_c('font-awesome-icon',{attrs:{"icon":"clone"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }